"use client";

import * as Dialog from "@radix-ui/react-dialog";
import { Drawer } from "vaul";
import { useWalletConnectModalContext } from "../providers/wallet-connect-modal-provider";
import { TrackingBoundary } from "../../../lib/sentry/index";
import type { WalletConnectModalTriggerProps } from "../types";

export function WalletConnectModalTrigger({
  asChild,
  children,
}: WalletConnectModalTriggerProps) {
  const { isMobile } = useWalletConnectModalContext();
  const Trigger = isMobile ? Drawer.Trigger : Dialog.Trigger;

  return (
    <TrackingBoundary feature="wallet_connect">
      <Trigger asChild={asChild ?? children != null}>
        {children ?? (
          <button type="button" data-track="open">
            Connect Wallet
          </button>
        )}
      </Trigger>
    </TrackingBoundary>
  );
}
